export default {
  type: "object",
  category: "app",
  target: { type: "app", key: "app" },
  groups: ["year 3", "year 4", "year 5", "year 6"],
};
